
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  RcsAgent,
  RcsAgentCardState,
  RcsSelectableSender,
  getRcsAgentCardState,
  isRcsAgentAwaitingPublish,
  isRcsAgentDeletable,
  isRcsAgentEditable,
  isRcsAgentPendingRemoteSync,
} from '@/types/rcs-onboarding';

const BADGE_ICONS: Record<RcsAgentCardState, string> = {
  active: 'fa-solid fa-circle-check',
  pending: 'fa-solid fa-clock',
  draft: 'fa-solid fa-file-pen',
  rejected: 'fa-solid fa-circle-xmark',
  failed: 'fa-solid fa-triangle-exclamation',
};

export default defineComponent({
  name: 'RcsAgentsListStep',

  props: {
    sharedSender: {
      type: Object as PropType<RcsSelectableSender>,
      required: true,
    },
    agents: {
      type: Array as PropType<RcsAgent[]>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['create', 'edit', 'delete', 'retry', 'push'],

  setup() {
    const { t } = useI18n();
    const cardState = (agent: RcsAgent): RcsAgentCardState => getRcsAgentCardState(agent);
    const isEditable = (agent: RcsAgent): boolean => isRcsAgentEditable(agent);
    const badgeIcon = (agent: RcsAgent): string => BADGE_ICONS[getRcsAgentCardState(agent)];
    const isPendingSync = (agent: RcsAgent): boolean => (
      isRcsAgentPendingRemoteSync(agent)
    );
    const canDeleteAgent = (agent: RcsAgent): boolean => isRcsAgentDeletable(agent);
    const pushActionLabel = (agent: RcsAgent): string => (
      isRcsAgentAwaitingPublish(agent)
        ? t('storeParameters.services.rcsServiceParameter.agentsList.actions.publishAgent')
        : t('storeParameters.services.rcsServiceParameter.agentsList.actions.applyChanges')
    );
    return {
      t,
      cardState,
      isEditable,
      badgeIcon,
      isPendingSync,
      canDeleteAgent,
      pushActionLabel,
    };
  },
});
